var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import UrlPattern from 'url-pattern';
export function partial(path) {
  path = withLeadingSlash(path);
  var pattern = new UrlPattern(path === '/' ? '*' : path + '/*');
  return {
    type: 'partial',
    match: createMatcher(pattern),
    stringify: function stringify(params) {
      return withoutTrailingSlash(pattern.stringify(_extends({
        _: ''
      }, params)));
    }
  };
}
export function full(path) {
  path = withLeadingSlash(path);
  var pattern = new UrlPattern(path === '/' ? '(/)' : path + '(/)');
  return {
    type: 'full',
    match: createMatcher(pattern),
    stringify: function stringify(params) {
      return pattern.stringify(params);
    }
  };
}
export function any(path) {
  return {
    type: 'any',
    match: function match(url) {
      return {
        matched: true,
        params: null,
        parentUrl: '',
        segment: url,
        remaining: ''
      };
    },
    stringify: function stringify(params) {
      throw new Error('Cannot stringify `any` URL');
    }
  };
}

function createMatcher(pattern) {
  return function (current, full) {
    var result = pattern.match(typeof current === 'string' ? withTrailingSlash(current) : current);

    if (result) {
      var _ = result._,
          _params = _objectWithoutProperties(result, ['_']);

      var _segment = pattern.stringify(_extends({}, _params, {
        _: ''
      }));

      var _parentUrl = typeof full === 'string' ? full.replace(new RegExp(escapeRegExp('' + _segment + (_ || '')) + '/?$'), '') : '';

      var normalizedParams = pattern.names.reduce(function (acc, k) {
        if (k !== '_') {
          acc[k] = _params[k] || null;
        }

        return acc;
      }, {});
      return {
        matched: true,
        params: normalizedParams,
        parentUrl: _parentUrl,
        segment: withoutTrailingSlash(_segment),
        remaining: _ ? withLeadingSlash(_) : _
      };
    } else {
      return {
        matched: false,
        params: null,
        parentUrl: '',
        segment: '',
        remaining: current || ''
      };
    }
  };
}

function withLeadingSlash(path) {
  return path.startsWith('/') ? path : '/' + path;
}

function withTrailingSlash(path) {
  return path.endsWith('/') ? path : path + '/';
}

function withoutTrailingSlash(x) {
  var match = x.match(/(.*?)\/?$/);
  return match ? match[1] : x;
}

function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}